import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "./../../../environments/environment";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PriLoginService {

  private readonly successPage: BehaviorSubject<string> = new BehaviorSubject(
    "Password Reset Successfully"
  );
  private readonly userEmail: BehaviorSubject<string> = new BehaviorSubject("");
  private readonly userIdp: BehaviorSubject<string> = new BehaviorSubject("");
  public readonly IDPList = new BehaviorSubject([]);
  public readonly opcoConfig: BehaviorSubject<object> = new BehaviorSubject({
    logoUrl: "",
    title: "Welcome to Life Science Digital",
    footer: "Life Science Digital. All right are reserved",
    redirectUrl: "",
    tenantId: "",
    cssPath: "",
    adminEmail: "iot@dhr.com",
    name: "",
    clientID: "",
    userPoolDomainName: "",
    userPoolID: "",
    IDP: "",
    language: "EN",
    authority:""
  });
  public hasUserConsent: BehaviorSubject<string> = new BehaviorSubject("");
  public loginMessage: BehaviorSubject<object> = new BehaviorSubject({
    errorMessage: "",
    successMessage: "Login successful",
  });
  private readonly contentType = "application/json";
  private readonly headers = new HttpHeaders().set(
    "Content-Type",
    this.contentType
  );
  private readonly requestOptions = {
    headers: this.headers,
    withCredentials: false,
  };
  constructor(private readonly httpClient: HttpClient) {}

  getSuccessPage(): Observable<string> {
    return this.successPage.asObservable();
  }

  setSuccessPage(obj: string) {
    this.successPage.next(obj);
  }


  setUserEmail(email: string) {
    this.userEmail.next(email);
  }

  getUserEmail(): Observable<string> {
    return this.userEmail.asObservable();
  }

  setIdp(idp: string) {
    this.userIdp.next(idp);
  }

  getIdp(): Observable<string> {
    return this.userIdp.asObservable();
  }

  public resetPassword(obj: any, uid: string): Observable<any> {
    const headerObj = {
      "Content-Type": this.contentType,
      tenantid: this.opcoConfig.value["tenantId"],
    };
    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      withCredentials: false,
    };
    const url = `${environment.baseUrl}${environment.resetPassword}${uid}`;
    return this.httpClient.patch(url, obj, requestOptions);
  }
  public login(obj: any): Observable<any> {
    const headerObj = {
      "Content-Type": this.contentType,
      tenantId: this.opcoConfig.value["tenantId"],
    };
    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      withCredentials: false,
    };
    const url = `${environment.login}`;
    return this.httpClient.post(url, obj, requestOptions);
  }
  public forgotPasswordEmail(obj: any): Observable<any> {
    const headerObj = {
      "Content-Type": this.contentType,
      tenantID: this.opcoConfig.value["tenantId"],
    };
    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      withCredentials: false,
    };
    const url = `${environment.baseUrl}${environment.ForgotPassworLink}${obj.email}`;
    return this.httpClient.patch(url, {}, requestOptions);
  }
  public forgotPasswordChange(obj: any): Observable<any> {
    const headerObj = {
      "Content-Type": this.contentType,
      tenantid: this.opcoConfig.value["tenantId"],
    };
    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      withCredentials: false,
    };
    const url = `${environment.baseUrl}${environment.ForgotPasswor}`;
    return this.httpClient.patch(url, obj, requestOptions);
  }

  getPasswordGuidelines(): Observable<any> {
    const headerObj = {
      "Content-Type": this.contentType,
      tenantId: this.opcoConfig.value["tenantId"],
    };
    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      withCredentials: false,
    };
    const url = `${environment.baseUrl}${environment.passwordGuildelines}`;
    return this.httpClient.get(url, requestOptions);
  }

  public getPrivacyPolicyLink(): Observable<any> {
    const url = `${environment.baseUrl}${environment.ForgotPasswor}`;
    return this.httpClient.get(url, this.requestOptions);
  }

  public getOpcoConfiguration(opco): void {
    const headers = new HttpHeaders({
      "Content-Type": this.contentType,
      operation: "get_tenant_basic_profile",
    });
    this.httpClient
      .get(`${environment.lamdaUrl}get_tenant_basic_profile?name=${opco}`, {
        headers,
      })
      .subscribe((res) => {
        this.opcoConfig.next(res);
      });
  }

  async getAuthorityUrl(opco): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": this.contentType,
      operation: "get_tenant_basic_profile",
    });


    return firstValueFrom(this.httpClient
      .get(`${environment.lamdaUrl}get_tenant_basic_profile?name=${opco}`, {
        headers,
      }));
  }

  public updateIDPList(list): void {
    this.IDPList.next(list);
  }

  public getIDPList(username): Promise<any> {
    const headerObj = {
      "Content-Type": this.contentType,
    };

    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": true,
    };
    return this.httpClient
      .post(
        `${environment.lmsEndpoint}${environment.getUserTypeUri}`,
        { username },
        requestOptions
      )
      .toPromise();
  }

  public getAshtonToken(reqObj): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": this.contentType,
      tenantID: sessionStorage.getItem("tenantId"),
    });
    const requestOptions = {
      headers,
      withCredentials: false,
    };
    return this.httpClient.post(
      `${environment.authentication}exchange_token`,
      reqObj,
      requestOptions
    );
  }

  // Will able to get the data from cognito
  public getOIDCConfig(domainId): Observable<any> {
    return this.httpClient.get(
      `https://cognito-idp.${
        domainId.split("_")[0]
      }.amazonaws.com/${domainId}/.well-known/openid-configuration`
    );
  }

  public resendInvitationLink(obj: any): Observable<any> {
    const headerObj = {
      "Content-Type": "application/json",
      tenantId: this.opcoConfig.value["tenantId"],
    };
    const requestOptions = {
      headers: new HttpHeaders(headerObj),
      withCredentials: false,
    };
    return this.httpClient.post(
      `${environment.baseUrl}/invite_link_expiry`,
      obj,
      requestOptions
    );
  }
}
